<div  class="modal fade" id="downtime-banner-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': this.universalService.isDowntimeBannerModal ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <!-- .cards.length >= 1 -->
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90" [ngClass]="!this.universalService.isMobileDevice ? 'full-width' : ''">
          <div class="modal-header border-bottom-0 p-0">
            <button type="button" class="close btn-pos blocking-banner-close" data-dismiss="modal" (click)="closeBanner();">
              <span class="NeueFile_Cancel"></span>
              <span class="esc">esc</span>
            </button>
          </div>
        <div class="modal-body border-bottom-0">
            <div class="banner-content mt-0" >
              @if (!this.universalService.isMobileDevice) {
                <img src="https://static.jiocloud.com/banners/maintenance-web-desktop-2.png" class="img-resposive" alt="" />
              }
              @if (this.universalService.isMobileDevice) {
                <img src="https://static.jiocloud.com/banners/maintenance-web-mobile-2.png" class="img-resposive" alt=""/>
              }
            </div>
        </div>
      </div>
    </div>
  </div>